
import { Component, EventEmitter, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';


@Component({
    selector: 'app-buy-search',
    templateUrl: './buy-search.component.html',
    styleUrls: ['./buy-search.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class BuySearchComponent {

  businessLine: CarBusinessLine = CarBusinessLine.BUY; 

}